<script>
    import { onMount } from "svelte";
    import { link } from "svelte-spa-router";
    import { searchFunds, getFund } from "../api/fund.js";
    import Shimmer from "../atoms/Shimmer.svelte";

    $: title = ""
    $: search = ""
    $: checkResults = false

    const getFunds = async f => {
        if (title == "") {
            return f
        }
        let funds = await searchFunds(title, 0, 50);

        let newFunds = [];
        for (let fund of funds.funds) {
            console.log(fund)
            let f = await getFund(fund.fund_id);
            f.id = fund;
            newFunds.push(f);
        }
        console.log(funds.count)
        return { funds: newFunds, count: funds.count};
    }

    let funds = {funds: [], count: 0};
    $: console.log(funds, "wooga")

    const research = e => {
        if (event.keyCode == 13) {
            search = title
            funds = getFunds(funds);
        }
    }
</script>

<div class="search-page" style="width: 100%;">
    <div class="serch container" style="border: 1px solid #DDD; background-color: white;">
        <i class="search icon" style="margin-left: 8px;"/>
        <input bind:value={title} on:keydown={research} class="serch" placeholder="Search for a Fundraiser" style="width: calc(100% - 1.19em - 0.5rem - 8px); border: none;"/>
    </div>

    {#await funds}
        <div class="results">
            <div style="height: 2rem;"></div>
            <div style="height: 4px;"></div>
            <Shimmer height="1.17em" width="90%"/>
            <div style="height: 6px;"></div>
            <Shimmer height="1em" width="20%"/>

            <div style="height: 8px;"></div>
            <div class="line"></div>
            <div style="height: 4px;"></div>
            <Shimmer height="1.17em" width="90%"/>
            <div style="height: 6px;"></div>
            <Shimmer height="1em" width="20%"/>

            <div style="height: 8px;"></div>
            <div class="line"></div>
            <div style="height: 4px;"></div>
            <Shimmer height="1.17em" width="90%"/>
            <div style="height: 6px;"></div>
            <Shimmer height="1em" width="20%"/>
        </div>
    {:then funds}
        {#if !(search == "" && funds.count == 0)}
            <div class="results">
                {#if funds.count == 0}
                    <div style="width: 100%; display: flex; justify-content: center;">
                        <h3>No Results</h3>
                    </div>
                {:else}
                    {funds.count} results
                {/if}
                {#each funds.funds as fund, i}
                    <div class="result">
                        {#if i != 0}
                            <div class="line"></div>
                        {/if}
                        <a use:link={"/fund/" + fund.fund_id}>
                            <h3>
                                {fund.title}
                            </h3>
                        </a>
                        <p>
                        {new Date(fund.start_date).toLocaleDateString()}
                        </p>
                    </div>
                {/each}
            </div>
        {/if}
    {/await}
</div>

<style>
    .search-page {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .results {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .container {
        width: 100%;
    }
    .serch {
        border-radius: 0.4rem !important;
        outline: none;
    }
    .search:focus-visible {
        outline: none;
        border-radius: 0.4rem !important;
    }
    @media only screen and (min-width: 768px) {
        .container {
            width: 60%;
        }
        .results {
            width: 60%;
        }
    }
    .result {
        width: 100%;
    }
    .line {
        height: 1px;
        background-color: #CCC;
        width: 100%;
    }
    h3 {
        margin-bottom: 4px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    p {
        margin-top: 4px;
    }
</style>
